// extracted by mini-css-extract-plugin
module.exports = {"bgWrapper":"styles_bgWrapper__KFQOR","title":"styles_title__1EuMn"};